import { TaskFormPayload } from 'api';
import { TaskFormValues } from 'types';
import { removeExtraSpaces } from 'utils';

interface FormValuesAdapterProps extends TaskFormValues {
  file_ids: string[];
}

export function formValuesAdapter({
  title,
  description,
  status,
  assignee,
  images,
  docs,
  deadline,
  progress,
  priority,
  ...otherProps
}: FormValuesAdapterProps): TaskFormPayload {
  return {
    title: removeExtraSpaces(title),
    description: removeExtraSpaces(description),
    type: 'tasks',
    ...(status && {
      task: {
        state: status,
        deadline,
        progress,
        ...(priority !== undefined && { priority }),
      },
    }),
    ...(assignee && { assigned_to: assignee }),
    ...otherProps,
  };
}
